export function createPendingWorkByKey() {
    const pendingPromises = new Map<string, Promise<void>>();

    return {
        has(key: string) {
            return pendingPromises.has(key);
        },
        forKeys(keys: string[]) {
            return keys.flatMap((key) => {
                const pendingPromise = pendingPromises.get(key);
                return pendingPromise ? [pendingPromise] : [];
            });
        },
        track(keys: string[], work: () => Promise<void>) {
            const uniqueKeys = [...new Set(keys)];
            if (uniqueKeys.some((key) => pendingPromises.has(key))) {
                throw new Error("Cannot replace pending work for the same key");
            }
            const trackedPromise = Promise.resolve()
                .then(work)
                .finally(() => {
                    for (const key of uniqueKeys) {
                        pendingPromises.delete(key);
                    }
                });

            for (const key of uniqueKeys) {
                pendingPromises.set(key, trackedPromise);
            }

            return trackedPromise;
        },
    };
}
